import { render } from "./BrowseArtwork.vue?vue&type=template&id=5f17ab90&scoped=true"
import script from "./BrowseArtwork.vue?vue&type=script&lang=js"
export * from "./BrowseArtwork.vue?vue&type=script&lang=js"

import "./BrowseArtwork.vue?vue&type=style&index=0&id=5f17ab90&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f17ab90"]])

export default __exports__